import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  tableContainer: {
    "& table$table": {
      minWidth: 700,
      borderSpacing: "5px",
      borderCollapse: "separate",
      "-webkit-border-horizontal-spacing": 0,
    },
    overflow: "initial",
  },
  table: {
    tableLayout: "fixed",
  },
  tableHead: {
    "& :first-child > $tableHeader": {
      height: 12,
      borderTop: "none",
    },
    "& tr$tableRow": {
      height: 32,
      background: "none",
      "&:hover": {
        outline: "none",
      },
    },
  },
  tableHeader: {
    height: 12,
    border: "none",
    background: "none",
  },
  tableBody: {
    "& tr$tableRow": {
      height: 42,
      background: theme.hv.palette.atmosphere.atmo2,
    },
    "& td$tableCellAction": {
      borderLeft: `solid 2px ${theme.hv.palette.atmosphere.atmo2}`,
    },
  },
  tableRow: {},
  tableCell: {
    border: "none",
  },
  tableCellAction: {
    width: 34,
    maxWidth: 34,
  },
  noData: {
    padding: 32,
  },
}));

export default styles;
